/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';

/**
 * 
 * @export
 * @interface GetAssetsBatchResponse
 */
export interface GetAssetsBatchResponse {
    /**
     * 
     * @type {Array<Asset>}
     * @memberof GetAssetsBatchResponse
     */
    assets: Array<Asset>;
}

/**
 * Check if a given object implements the GetAssetsBatchResponse interface.
 */
export function instanceOfGetAssetsBatchResponse(value: object): value is GetAssetsBatchResponse {
    if (!('assets' in value) || value['assets'] === undefined) return false;
    return true;
}

export function GetAssetsBatchResponseFromJSON(json: any): GetAssetsBatchResponse {
    return GetAssetsBatchResponseFromJSONTyped(json, false);
}

export function GetAssetsBatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssetsBatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assets': ((json['assets'] as Array<any>).map(AssetFromJSON)),
    };
}

export function GetAssetsBatchResponseToJSON(json: any): GetAssetsBatchResponse {
    return GetAssetsBatchResponseToJSONTyped(json, false);
}

export function GetAssetsBatchResponseToJSONTyped(value?: GetAssetsBatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assets': ((value['assets'] as Array<any>).map(AssetToJSON)),
    };
}

